export default "__VITE_ASSET__DECc7pVQ__"